module.exports = __webpack_public_path__ + "img/potato.11626936.svg";